// extracted by mini-css-extract-plugin
module.exports = {"playerName":"styles_playerName__1pwrG","name":"styles_name__2h8qV"};